const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content integration config
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {ApiApplications} ApiApplications injected to gain access to the ApiApplications resource
 */
app.directive('apiApplicationsManager', ['Application', 'Authorization', 'ApiApplications', '$translate', function (Application, Authorization, ApiApplications, $translate) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      tabWatch: '='
    },
    template: require('../../templates/directives/api-applications-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.newSettings = {};
      self.exposed = {};
      self.appToRemove = null;

      self.getDescription = function(app) {
        if (!app || !app.application_info || !app.application_info.length) {
          return '';
        }
        for (var i = 0; i < app.application_info.length; i++) {
          if (app.application_info[i] && app.application_info[i].name === 'description') {
            return app.application_info[i].value || '';
          }
        }
        return '';
      };

      self.create = function() {
        ApiApplications.create({}, {application_name: self.newSettings.name, application_info: {name: 'description', value: self.newSettings.description}}).$promise
        .then(function(results) {
          self.newSettings = {};
          self.creating = false;
          self.initialize();
        }).catch(function(error) {
          console.log('error: ', error)
        });
      };

      self.showRemoval = function(app) {
        self.appToRemove = app;
        self.showRemoveConfirmation = true;
      };

      self.cancelRemoval = function() {
        self.showRemoveConfirmation = false;
        self.appToRemove = null;
      };

      self.remove = function() {
        if (!self.appToRemove || !self.appToRemove._id) {
          return;
        }
        ApiApplications.remove({subresource: self.appToRemove._id}).$promise
        .then(function(results) {
          self.appToRemove = null;
          self.showRemoveConfirmation = false;
          self.initialize();
        }).catch(function(error) {
          console.log('error: ', error)
        });
      };

      self.expose = function(id) {
        ApiApplications.expose({subresource: id}).$promise
        .then(function(results) {
          if (results && results.client_secret) {
            self.exposed[id] = results.client_secret;
          }
        }).catch(function(error) {
          console.log('error: ', error)
        });
      };

      self.initialize = function() {
        self.loading = true;
        if (!self.user || !self.user.role || self.user.role !== 'admin') {
          Application.navigation.back();
          return;
        }
        self.editing = false;

        ApiApplications.find({fields: 'client_id,application_name,application_info'}).$promise.then(function(apps) {
          self.apps = apps || [];
          if (!self.apps || !self.apps.length) {
            self.creating = true;
          }
          self.loading = false;
        }).catch(function(err) {
          console.log(err);
          $translate('apiAppManager.error_retrieving').then(function (translation) {
            Application.messaging.addMessage({type: 'error', text: translation, duration: 5});
          });
          self.loading = false;
        });
      };

      self.initialize();

    }],
    controllerAs: 'apiCreds'
  };
}]);